"use strict";
(self["webpackChunkapp"] = self["webpackChunkapp"] || []).push([["apps_app_src_app_personal-number_i18n_personal-number_en_json"],{

/***/ 4113:
/***/ ((module) => {

module.exports = JSON.parse('{"heading":"Missing Swedish personal number","missingPersonalNumber":"You are missing a Swedish personal number on your account.","addressPersonalNumber":"You are required to provide the necessary information to proceed.","noSwedishPnr":"I don\'t have a Swedish personal number","error":"An error has occurred, please make sure your information is correct before trying again.","invalidPnr":"Invalid Swedish personal number. Please enter the number in the format YYMMDD-XXXX.","personalNumber":"Swedish personal number*","accept":"Save","cancel":"Log out"}');

/***/ })

}]);